import React from 'react';

const Slider = props => {
  return (
    <div className={`slider ${props.mainWrapperClassName}`}>
      {props.label &&
      <label className='main-label'>
        {props.label}
      </label>}
      <label className={`slider-body ${props.sliderBodyClassName} ${props.disabled ? 'slider-body_disabled' : ''}`} onClick={props.disabled ? () => {} : props.toggleAction}>
        {props.onLabel}
        <div className={`${props.state ? 'on' : 'off'}`}>
          <div className='ect-slider-dot' />
        </div>
        {props.offLabel}
      </label>
    </div>
  );
};

Slider.defaultProps = {
  color: ''
};

export default Slider;



// WEBPACK FOOTER //
// ./src/app/Components/Slider.jsx